import { createRoute, lazyRouteComponent, redirect } from "@tanstack/react-router";

const BusinessesPage = lazyRouteComponent(() => import("@modules/admin/pages/BusinessesPage"), "BusinessesPage");
const SubdomainsPage = lazyRouteComponent(() => import("@modules/admin/pages/SubdomainsPage"), "SubdomainsPage");

export function getRoutes(parentRoute) {
  return [
    createRoute({
      getParentRoute: () => parentRoute,
      path: "/admin",
      beforeLoad: () => {
        throw redirect({ to: "/admin/subdomains" });
      },
    }),
    createRoute({ getParentRoute: () => parentRoute, path: "/admin/businesses", component: BusinessesPage }),
    createRoute({ getParentRoute: () => parentRoute, path: "/admin/subdomains", component: SubdomainsPage }),
  ];
}
